// extracted by mini-css-extract-plugin
export const donorboxContainerContainer = "donate-module--donorboxContainerContainer--3cvVx";
export const donorboxContainer = "donate-module--donorboxContainer--1L7ED";
export const donorboxIframeContainer = "donate-module--donorboxIframeContainer--3dnNp";
export const donorboxExplanation = "donate-module--donorboxExplanation--UnS1E";
export const donateImage = "donate-module--donateImage--p0csX";